module.exports = __webpack_public_path__ + "assets/media/sandbox.7c107d02.mp4";